























import { defineComponent } from '@nuxtjs/composition-api';

import { SimpleProductInterface } from '~/modules/catalog/category/components/tiles/simpleProductInterface';
import SimpleTile from '~/modules/catalog/category/components/tiles/SimpleTile.vue';

export default defineComponent({
  components: { SimpleTile },
  props: {
    title: {
      type: String,
      required: true,
    },
    collection: {
      type: Array as () => SimpleProductInterface[],
      default: () => [],
    },
  },
});
